import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';

export function useDeleteBackgroundControlFile() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (backgroundControlFileId: string) => {
      const api = await getApi();

      const res = await api.backgroundControlsDeleteReportFile(
        backgroundControlFileId
      );
      await queryClient.invalidateQueries();

      return res.data;
    },
    onSuccess: () => toast.success('Filen raderades'),
    onError: () => toast.error('Fel, kunde inte radera filen'),
  });
}
